import { memo } from "react";

import TableCellText from "ds/components/Table/Row/CellText";

import { type RenderGroupRowCellProps } from ".";
import PersonalSettingsSpacesGroupCell from "../Cell";
import { isSpaceActionsGroup } from "../../../helpers";

const PersonalSettingsSpacesTableGroupRowCellPermissions = memo(
  (props: RenderGroupRowCellProps) => {
    const { row } = props;

    return (
      <PersonalSettingsSpacesGroupCell {...props}>
        <TableCellText>{isSpaceActionsGroup(row) ? row.actions.length : 0}</TableCellText>
      </PersonalSettingsSpacesGroupCell>
    );
  }
);

PersonalSettingsSpacesTableGroupRowCellPermissions.displayName =
  "PersonalSettingsSpacesTableGroupRowCellPermissions";

export default PersonalSettingsSpacesTableGroupRowCellPermissions;
